<template>
    <div class="container header__top">
        <h1 class="header__logo header__logo--d">
            <a href="/" class="header__logo-link">
                <img src="/assets/front/img/logo.png" class="header__logo-img" alt="#">
            </a>
        </h1>
        <div class="header__info">
            <div class="header__info-item">
                <svg class="header__info-icon">
                    <use xlink:href="/assets/front/img/sprite.svg#icon-hammer"></use>
                </svg>
                <span class="header__info-value">{{ headerStatistics.onAuctionsToday }}</span>
                <span class="header__info-name">Сегодня на<br> аукционах</span>
            </div>
            <div class="header__info-item">
                <svg class="header__info-icon">
                    <use xlink:href="/assets/front/img/sprite.svg#icon-seal"></use>
                </svg>
                <span class="header__info-value">{{ headerStatistics.soldOnAuctions }}</span>
                <span class="header__info-name">Продано на<br> аукционах</span>
            </div>
            <div class="header__info-item">
                <svg class="header__info-icon">
                    <use xlink:href="/assets/front/img/sprite.svg#icon-user"></use>
                </svg>
                <span class="header__info-value">{{ headerStatistics.registeredUsers }}</span>
                <span class="header__info-name">Зарегистрировано<br> покупателей</span>
            </div>
            <div class="header__info-item">
                <svg class="header__info-icon">
                    <use xlink:href="/assets/front/img/sprite.svg#icon-lock"></use>
                </svg>
                <span class="header__info-value">{{ headerStatistics.onlineUsers }}</span>
                <span class="header__info-name">Покупателей <br> онлайн</span>
            </div>
            <div class="header__info-item">
                <svg class="header__info-icon">
                    <use xlink:href="/assets/front/img/sprite.svg#icon-bet"></use>
                </svg>
                <span class="header__info-value">{{ headerStatistics.madeBids }}</span>
                <span class="header__info-name">Сделано <br> ставок</span>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "../../../js/modules/ApiService";

export default {
    name: "HeaderStatistics",
    data: () => ({
        headerStatistics: window.laravel.headerStatistics,
    }),
    created() {
        this.checkOnlineUsers();
    },
    methods: {
        checkOnlineUsers() {
            setInterval(() => {
                new ApiService()
                    .get('/header-statistics')
                    .then((response) => {
                        this.headerStatistics = response.data.headerStatistics;
                    })
            }, 30000);
        }
    }
}
</script>

<style scoped>

</style>
